"use client";
import flatten from "lodash/flatten";
import Image from "next/image";

import IconCheckGreen from "@/components/Icon/IconCheckGreen.svg";
import IconRemove from "@/components/Icon/IconRemove.svg";

import classNames from "classnames";
import styles from "./styles.module.scss";
import { use, useEffect } from "react";
import Link from "next/link";
import { getData } from "../SizeSelector";
import Spinner from "@/components/Spinner";

export default function Availability({
  inventories = [],
  selectedVariant,
  product = {},
  setCartDisabled,
  variants,
  saleorVariants,
  setSizeVariants = () => {},
  setInventories = () => {},
  bbaProductPromise,
}) {
  const bbaProduct = use(bbaProductPromise);
  const sizeVariants = bbaProduct.simple_products || [];
  setSizeVariants(sizeVariants);
  setInventories(bbaProduct.inventories || []);
  const { sizeData } = getData(variants, saleorVariants);
  const sizes = sizeData.filter(variant => variant.attributeValue);

  const countReducer = (accumulator, currentValue) => accumulator + currentValue.inventoryCount;
  const simpleInventories = flatten(
    sizeVariants.map(simple => {
      return simple.inventories;
    })
  );

  const parramattaStore = inventories.find(
    item => item.ownerType == "warehouse" && item.ownerName.includes("Parramatta")
  );
  const parramattaStoreCount = parramattaStore ? parramattaStore.inventoryCount : 0;

  const granvilleStore = inventories.find(
    item => item.ownerType == "warehouse" && item.ownerName.includes("Granville")
  );
  const granvilleStoreCount = granvilleStore ? granvilleStore.inventoryCount : 0;

  const suppiler = inventories.find(item => item.ownerType == "supplier" && item.inventoryCount > 0);
  const supplierCount = suppiler?.inventoryCount || 0;
  let totalLeadTime = 0;
  if (parramattaStoreCount || granvilleStoreCount) {
    totalLeadTime = 1;
  } else if (supplierCount) {
    totalLeadTime = suppiler?.leadTime + 1;
  }

  const totalInventoryCount = inventories.reduce(countReducer, 0);
  const totalSimpleInventoryCount = simpleInventories.reduce(countReducer, 0);

  let skuNumber = "";

  if (selectedVariant) {
    skuNumber = selectedVariant.sku;
  } else if (!product?.productType?.hasVariants && product.variants) {
    // setChecking(true);
    skuNumber = product.variants[0].sku;
  }

  if (totalInventoryCount === 0 && selectedVariant?.quantityAvailable > 0) {
    console.warn("This variant is mismatched quantity, will be fixed soon");
  }
  useEffect(() => {
    if (totalInventoryCount > 0 || totalSimpleInventoryCount > 0) {
      setCartDisabled(false);
    } else {
      setCartDisabled(true);
    }
  }, [totalInventoryCount, totalSimpleInventoryCount, setCartDisabled]);
  return (
    <div className="w-full flex flex-col mt-8 border-[1px] border-grey-200 bg-white relative rounded-sm">
      <div className={classNames(!selectedVariant && sizes.length > 0 ? styles.blur : "")}>
        <div className="border-b-[1px] border-grey-200 py-[10px] px-6">
          <label className="text-sm font-bold">SKU/part number:</label>
          <label className="text-sm font-[500] ml-1">{skuNumber}</label>
        </div>
        <div className="px-6">
          <div className="border-b-[1px] border-grey-200 py-4 ">
            <div className="text-sm font-bold mb-2 text-grey">Stock Availability</div>
            <div className="flex">
              <div className="min-w-[18px] min-h-[18px] mr-[10px]">
                {totalLeadTime > 0 ? (
                  <Image src={IconCheckGreen.src} alt="" width={18} height={18} className="w-[18px] h-[18px]" />
                ) : (
                  <Image src={IconRemove.src} width="16" height="16" alt="remove" />
                )}
              </div>
              <div className="w-3/12 text-sm font-bold">Online</div>
              <div className="w-7/12 text-sm ml-auto">
                {totalLeadTime > 0
                  ? `Dispatched within ${totalLeadTime} day${totalLeadTime > 1 ? "s" : ""}`
                  : "Out of stock"}
              </div>
            </div>
          </div>
          <div className="border-b-[1px] border-grey-200 py-4 flex items-center">
            <div className="min-w-[18px] min-h-[18px] mr-[10px]">
              {parramattaStoreCount > 0 ? (
                <Image src={IconCheckGreen.src} alt="" width={18} height={18} className="w-[18px] h-[18px]" />
              ) : (
                <Image src={IconRemove.src} width="16" height="16" alt="remove" />
              )}
            </div>

            <div className="w-3/12 text-sm font-bold">Bikebiz Parramatta Store</div>
            <div className="w-7/12 flex flex-col ml-auto">
              <Link href="tel: 02 8830 0550" className="text-sm underline">
                Call (02) 8830 0550
              </Link>
              <Link
                prefetch={false}
                href={"https://goo.gl/maps/Vfx7djK1bbh7VkVFA"}
                rel="noopener"
                className="text-sm underline "
                target="_blank"
              >
                7 Great Western Hwy, Parramatta 2150
              </Link>
            </div>
          </div>
          <div className="py-4 flex">
            <div className="min-w-[18px] min-h-[18px] mr-[10px]">
              {granvilleStoreCount > 0 ? (
                <Image src={IconCheckGreen.src} alt="" width={18} height={18} className="w-[18px] h-[18px]" />
              ) : (
                <Image src={IconRemove.src} width="16" height="16" alt="remove" />
              )}
            </div>
            <div className="w-3/12 text-sm font-bold">Bikebiz Granville Store</div>
            <div className="w-7/12 flex flex-col ml-auto">
              <Link href="tel: 02 9682 2950" className="text-sm underline">
                Call (02) 9682 2999
              </Link>
              <Link
                prefetch={false}
                href={"https://goo.gl/maps/jE9fjZCCFWKj73Gx6"}
                rel="noopener"
                className="text-sm underline"
                target="_blank"
              >
                274 Parramatta Rd, Granville NSW 2142
              </Link>
            </div>
          </div>
        </div>
      </div>
      {!selectedVariant && sizes.length > 0 && (
        <p className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 font-bold text-center">
          Select from the options above to see product availability.
        </p>
      )}
      {/* {sizes.length <= 0 &&  <Spinner text="Checking real-time stock information..." />} */}
    </div>
  );
}
